function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* eslint-disable */ // ReSharper disable InconsistentNaming
export class EventsApiClient {
    getDetails(id) {
        let url_ = this.baseUrl + "/api/v1/events/details/{id}";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetDetails(_response);
        });
    }
    processGetDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText)=>{
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Returns multiple event details by their IDs.
     * @param ids (optional) 
     */ getDetailsByIds(ids) {
        let url_ = this.baseUrl + "/api/v1/events/details?";
        if (ids !== undefined && ids !== null) ids && ids.forEach((item)=>{
            url_ += "ids=" + encodeURIComponent("" + item) + "&";
        });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetDetailsByIds(_response);
        });
    }
    processGetDetailsByIds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText)=>{
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Returns a paginated overview of events. Automatically switches between grouped and
    ungrouped results based on active filters (date/location/region → ungrouped).
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param tags (optional) 
     * @param regions (optional) 
     * @param locations (optional) 
     * @param query (optional) 
     */ getOverview(page, pageSize, from, to, tags, regions, locations, query) {
        let url_ = this.baseUrl + "/api/v1/events/overview?";
        if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null) url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null) url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (tags !== undefined && tags !== null) tags && tags.forEach((item)=>{
            url_ += "tags=" + encodeURIComponent("" + item) + "&";
        });
        if (regions !== undefined && regions !== null) regions && regions.forEach((item)=>{
            url_ += "regions=" + encodeURIComponent("" + item) + "&";
        });
        if (locations !== undefined && locations !== null) locations && locations.forEach((item)=>{
            url_ += "locations=" + encodeURIComponent("" + item) + "&";
        });
        if (query !== undefined && query !== null) url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetOverview(_response);
        });
    }
    processGetOverview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Returns the available filter options (tags, regions, locations) for the event overview.
     */ getOverviewFilters() {
        let url_ = this.baseUrl + "/api/v1/events/overview/filters";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetOverviewFilters(_response);
        });
    }
    processGetOverviewFilters(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * A chronological list of future events, optionally filtered by last update date.
     * @param updatedAfter (optional) The minimum DateTime for the last update of the events to include in the results. 
    Defaults to UnixEpoch.
     * @param limit (optional) The maximum number of events to return (default is 10).
     * @param offset (optional) The number of events to skip before starting to collect the result set (default is 0).
     */ getUngrouped(updatedAfter, limit, offset) {
        let url_ = this.baseUrl + "/api/v1/events/ungrouped?";
        if (updatedAfter === null) throw new globalThis.Error("The parameter 'updatedAfter' cannot be null.");
        else if (updatedAfter !== undefined) url_ += "updatedAfter=" + encodeURIComponent(updatedAfter ? "" + updatedAfter.toISOString() : "") + "&";
        if (limit === null) throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetUngrouped(_response);
        });
    }
    processGetUngrouped(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText)=>{
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * A list of unique tags, regions, and locations for ungrouped events.
     */ getUngroupedFilters() {
        let url_ = this.baseUrl + "/api/v1/events/ungrouped/filters";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetUngroupedFilters(_response);
        });
    }
    processGetUngroupedFilters(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    constructor(baseUrl, http){
        _define_property(this, "http", void 0);
        _define_property(this, "baseUrl", void 0);
        _define_property(this, "jsonParseReviver", undefined);
        this.http = http ? http : window;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }
}
export class ApiException extends Error {
    static isApiException(obj) {
        return obj.isApiException === true;
    }
    constructor(message, status, response, headers, result){
        super(), _define_property(this, "message", void 0), _define_property(this, "status", void 0), _define_property(this, "response", void 0), _define_property(this, "headers", void 0), _define_property(this, "result", void 0), _define_property(this, "isApiException", true);
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}
